import React, { Component } from 'react'
import QrReader from 'react-qr-reader'
import { connect } from 'react-redux';
import {Button,Paper,Divider,CssBaseline,TextField,Link,Grid,Box,Typography,Container} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from "@material-ui/core/styles";
import { Helmet } from "react-helmet";
import {UserActions} from '../../redux/actions/UserActions';
import { history } from "../../components/helpers/History";
import QRCode from "react-qr-code";


const useStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    backgroundColor: '#fff',
    padding : theme.spacing(4),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  typography: {
    margin: theme.spacing(3),
  },divider:{
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3)
  },buttons: {
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
});

class QrCodeScanner extends React.Component {
    constructor(props) {
      super(props);
      const { appointmentId } = this.props.match.params
      this.state = {
        appointmentId : appointmentId
      }
  }

  handleScan = data => {
    if (data) {
      this.setState({
        result: data
      })
    }
  }
  handleError = err => {
    console.error(err)
  }

  render(){
    const classes = this.props.classes;
    return (
      <>
        <Helmet>
          <title>Patient portal | Qr code generator</title>
        </Helmet>
        <Container component="main" maxWidth="md">
        <CssBaseline />
        <Paper className={classes.paper}>
        <Typography gutterBottom variant="h4" color="primary" className={classes.typography}>Check in with qr code</Typography>
        
        <QRCode value={this.state.appointmentId}/>
        
        <div className={classes.buttons}>
                  <Button
                      variant="contained"
                      color="default"
                      className={classes.button}
                      onClick={()=>{history.goBack();}}
                      >
                          Back
                      </Button>

                    
                  </div>
       </Paper>
        </Container>
      </>
    );
  }
}


function mapStateToProps(state) {
  const  user  = state.authentication.user;
  return { user };
}

const mapDispatchToProps = (dispatch) => {
  return {
    submit: (user) => {
      dispatch(UserActions.changePassword(user));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(useStyles,{ withTheme: true })(QrCodeScanner));